import { getBadgeDetailsFormConfig } from '../../../../../ui/features/badge-management/utils/getBadgeDetailsFormConfig';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { Form } from '@juvare/common-form-ui/Form';
import React from 'react';
export const BadgeCreateHeaderInfoForm = ({ formRef, state, setState }) => {
    const { t } = useBadgingTranslation();
    return (React.createElement(Form, { ref: formRef, hideFormControls: true, data: state, config: getBadgeDetailsFormConfig(t), onChanged: (changed, submit) => {
            if (changed) {
                // ignore error to avoid error popup
                submit().catch(() => { });
            }
        }, onSubmit: (stateNext) => {
            return Promise.resolve(stateNext);
        }, onSubmitSuccess: (stateNext) => {
            setState(Object.assign({}, stateNext));
        } }));
};
